import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, KeycloakAuthInformation } from '@algoan/dashboard/model';

const initialState: AuthState = {};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateAuthInformation(state: AuthState, action: PayloadAction<KeycloakAuthInformation | undefined>) {
      state.authInformation = action.payload ? { ...action.payload, requestedAt: Date.now() } : undefined;
    },
  },
});

export const { reducer: authReducer } = authSlice;
export const { updateAuthInformation } = authSlice.actions;
